<template>
	<div
		class="flex w-full flex-col place-items-center items-center justify-center gap-6 md:gap-8"
	>
		<MessageDisplay
			:title-classes="titleClasses"
			:description-classes="descriptionClasses"
			:show-badges="false"
		>
			<template #title>{{ title }}</template>
			<template #description>{{ description }}</template>
			<template #icon>
				<IconMaterialSymbolsExclamation :class="iconClasses" />
			</template>
		</MessageDisplay>

		<div
			class="flex w-full flex-col items-center justify-center space-y-4 py-2 pb-8 md:w-3/5 md:flex-row md:space-x-8 md:space-y-0 md:px-12 md:py-4 md:pb-16"
		>
			<NuxtLink
				v-slot="{ href }"
				:to="homeUrl"
				custom
				class="w-full"
				@click="onGoToHomeClick"
			>
				<Button
					as="a"
					:href="href"
					variant="secondary"
					skeleton-classes="w-full"
					class="w-full gap-4 px-4 text-base md:text-lg"
				>
					<span>{{ goToHomeText }}</span>
				</Button>
			</NuxtLink>
			<NuxtLink
				v-if="propertyUrl"
				v-slot="{ href }"
				:to="propertyUrl"
				class="w-full"
				custom
				@click="onViewMoreClick"
			>
				<Button
					as="a"
					:href="href"
					variant="primary"
					class="w-full gap-4 px-4 text-base md:text-lg"
				>
					<span>{{ seePropertiesText }}</span>
					<IconMaterialSymbolsNorthEastRounded class="size-6 fill-primary" />
				</Button>
			</NuxtLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { UnavailablePropertyStateProps } from '.';

import MessageDisplay from '~/components/StatusMessageDisplay/MessageDisplay.vue';

defineProps<UnavailablePropertyStateProps>();
</script>
